import { Insight } from 'types/Insight';

export const insightSelectors = {
  companyIdSelector(insight: Insight) {
    return insight.companyId;
  },
  domainId(insight: Insight) {
    return insight.domainId;
  },
  riskProfileTokenSelector(insight: Insight) {
    return insight.riskProfileToken;
  },
  merchantIdSelector(insight: Insight) {
    return insight.merchantId;
  },
  isPartiallyPaidSelector(insight: Insight) {
    return insight.isPartiallyPaid;
  },
  offerIdSelector(insight: Insight) {
    return insight.offerId;
  },
  offeringIdSelector(insight: Insight) {
    return insight.offeringId;
  },
  isFullyPaidSelector(insight: Insight) {
    return insight.isFullyPaid;
  },
  isPayableSelector(insight: Insight) {
    return insight.isPayable;
  },
  isPayEnabledSelector(insight: Insight) {
    return insight.isPayEnabled;
  },
  tokenSelector(insight: Insight) {
    return insight.token;
  },
  openInvoicesSelector() {
    return [];
  }, // open invoices is not implemented yet in sale refactor
  view2PaySelector(insight: Insight) {
    return insight.view2pay;
  },
  paymentProcessorSelector(insight: Insight) {
    return insight.paymentProcessor;
  },
  shouldShowSchedulePaySelector(insight: Insight) {
    return insight.shouldShowSchedulePay;
  },
  shouldShowAutopaySelector(insight: Insight) {
    return insight.shouldShowAutopay;
  },
  paymentDueStatusSelector(insight: Insight) {
    return insight.paymentDueStatus;
  },
  b2bPayorVendorsSelector(insight: Insight) {
    return insight.vendors;
  },
  b2bPayorAccountsSelector(insight: Insight) {
    return insight.accounts;
  },
  b2bPayorRealmIdSelector(insight: Insight) {
    return insight.payorRealmId;
  },
  isPayorBusiness(insight: Insight): boolean {
    return insight?.payorSegmentation?.isBusiness;
  },
  isFirstTimeInCP(insight: Insight): boolean {
    return insight?.payorSegmentation?.isFirstTimeInCP;
  },
  isDebitCardEnabled(insight: Insight): boolean {
    return insight?.debitCardEnabled;
  },
  hasEverPaidSelector(insight: Insight): boolean {
    return !!insight?.payorSegmentation.previousPaymentDate;
  },
  batchUnpaidInvoices(insight: Insight) {
    return insight.batchUnpaidInvoices;
  },
  selectedBatchInvoices(insight: Insight) {
    return insight.selectedBatchInvoices || [];
  },
  financingOfferTitleSelector(insight: Insight) {
    return insight?.financingOffer?.title;
  },
  financingOfferRecipientTypeSelector(insight: Insight) {
    return insight?.financingOffer?.recipientType;
  },
  financingOfferSelector(insight: Insight) {
    return insight?.financingOffer?.offers?.[0];
  },
  financingOfferTrackingObjectDetailsSelector(insight: Insight) {
    return insight?.financingOffer?.trackingObjectDetail;
  },
  isValidFinancingOfferSelector(insight: Insight) {
    const { financingOffer } = insight;
    return (
      !!financingOffer &&
      !!financingOffer.title &&
      !!financingOffer.offers &&
      financingOffer.offers.length > 0
    );
  },
  freeTextEmailOINPEventStatusSelector(insight: Insight) {
    return insight?.freeTextEmailOINPEventStatus;
  },
  pageVariantSelector(insight: Insight) {
    return insight?.pageVariant;
  },
  canCancelSchedule(insight: Insight) {
    return insight?.canCancelSchedule;
  },
  growthRightHandSideSelector(insight: Insight) {
    return insight?.growthRightHandSide;
  },
  growthRightHandSideTreatmentKeySelector(insight: Insight) {
    return insight?.growthRightHandSide?.treatmentKey;
  },
};
